'use client'

const TermsPage = () => {

  return (
    <div className="min-h-screen pt-30 bg-zinc-900 text-white p-4 flex flex-col">
      <div className="flex-grow w-full mx-auto bg-white rounded-lg overflow-hidden shadow-2xl">
        <iframe
          src={`/pdf/en_terms.pdf#toolbar=0`} 
          title="Terms and Conditions"
          className="w-full h-full min-h-[100vh]"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default TermsPage;